const SvgXml = {};
export default SvgXml;
